import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'
import './styles.scss'

interface Props {
  placeholder?: string
  onChange?: (t: string) => void
  defaultValue?: string
  value?: string
}

const modules = {
  toolbar: [
    ['bold', 'italic'],
    [{ align: [] }],
    [{ list: 'ordered' }, { list: 'bullet' }],
    ['link'],
    ['clean']
  ]
}

const formats = ['bold', 'italic', 'align', 'list', 'bullet', 'link']

const WysiwygTextBox = ({
  defaultValue,
  placeholder,
  onChange = (t) => t,
  value,
  ...rest
}: Props) => {
  const handleChange = (_value: string) => {
    onChange(_value)
  }

  return (
    <ReactQuill
      defaultValue={defaultValue}
      value={value}
      placeholder={placeholder}
      modules={modules}
      formats={formats}
      onChange={handleChange}
      {...rest}
    />
  )
}

export default WysiwygTextBox
